import { createTheme, type Palette, type PaletteColor, type Theme as MuiTheme, useTheme } from "@mui/material/styles";

import { FontDefinitions } from "@/assets/fonts.ts";
import { buttonComponentOverrides } from "@/theme/components/ButtonOverrides.ts";
import { chipComponentOverrides } from "@/theme/components/ChipOverrides.ts";
import { skeletonComponentOverrides } from "@/theme/components/SkeletonOverrides.ts";
import { defaultTypographyOptions, TypographyComponentOverrides } from "@/theme/components/TypographyOverrides.ts";
import "@/theme/components/SwitchOverrides.ts";
import "@/theme/components/ToggleButtonOverrides.ts";
import { lightPalette } from "@/theme/LightTheme.ts";
import { ScreenSizes } from "@/theme/responsive.ts";

type CreateThemeDefinitionType = Parameters<typeof createTheme>[0];

declare module "@mui/material/styles" {
  interface BreakpointOverrides {
    xxl: true;
  }
}

export const createThemeDefinition: CreateThemeDefinitionType = {
  cssVariables: true,
  colorSchemes: {
    light: {
      palette: lightPalette,
    },
  },
  breakpoints: {
    values: {
      xs: ScreenSizes.XS,
      sm: ScreenSizes.SM,
      md: ScreenSizes.MD,
      lg: ScreenSizes.LG,
      xl: ScreenSizes.XL,
      xxl: ScreenSizes.XXL,
    },
    unit: "px",
  },

  defaultColorScheme: "light",
  spacing: (factor: number) => `${0.125 * factor}rem`,

  // Apply font typeset from Figma
  typography: defaultTypographyOptions,
  components: {
    MuiCssBaseline: {
      styleOverrides: `
    ${FontDefinitions.NunitoSans}
    `,
    },
    MuiButton: buttonComponentOverrides,
    MuiChip: chipComponentOverrides,
    MuiSkeleton: skeletonComponentOverrides,
    MuiTypography: TypographyComponentOverrides,
  },
};

export type Theme = MuiTheme;
export type { Palette, PaletteColor };
export { useTheme };

export const appTheme = createTheme(createThemeDefinition);
